import { render, staticRenderFns } from "./event-info.vue?vue&type=template&id=357e3599"
import script from "./event-info.vue?vue&type=script&lang=js"
export * from "./event-info.vue?vue&type=script&lang=js"
import style0 from "./event-info.vue?vue&type=style&index=0&id=357e3599&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports